import { render } from "./SpaceMenu.vue?vue&type=template&id=8adabc88&scoped=true"
import script from "./SpaceMenu.vue?vue&type=script&lang=js"
export * from "./SpaceMenu.vue?vue&type=script&lang=js"

import "./SpaceMenu.vue?vue&type=style&index=0&id=8adabc88&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8adabc88"],['__file',"src/components/space/SpaceMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8adabc88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8adabc88', __exports__)) {
    api.reload('8adabc88', __exports__)
  }
  
  module.hot.accept("./SpaceMenu.vue?vue&type=template&id=8adabc88&scoped=true", () => {
    api.rerender('8adabc88', render)
  })

}


export default __exports__